import React, { createContext, useContext, useState } from "react";

const translations = {
  ms: {
    nav_features: "Ciri-ciri", nav_pricing: "Harga", nav_solutions: "Penyelesaian", nav_demo: "Tempah Demo",
    nav_login: "Log Masuk", nav_trial: "Mula Percubaan Percuma",
    hero_badge: "Platform WhatsApp AI CRM #1 Malaysia",
    hero_title: "Jadikan WhatsApp Pasukan Jualan AI Anda.",
    hero_sub: "AI Chatbot. CRM. Team Inbox. Approved Broadcast. Automasi Jualan. Layani pelanggan 24/7, automasi follow-up, agih lead kepada pasukan anda dan ukur jualan dari WhatsApp.",
    hero_cta1: "Mula Percubaan Percuma", hero_cta2: "Tempah Demo",
    hero_from: "Dari RM99/bulan",
    hero_nocard: "Tiada kad diperlukan", hero_setup: "Setup 5 minit",
    lang_toggle: "EN",
    convert_label: "Jangan Sekadar Chat. Convert.",
    features_eyebrow: "Satu Platform",
    features_title: "Semua yang perlu untuk jual di WhatsApp.",
    features_sub: "WhatsApp kekal sebagai channel. Platform kami jadi lapisan AI, CRM, automasi & revenue di sekelilingnya.",
    f_chatbot_t: "AI WhatsApp Chatbot", f_chatbot_d: "AI jawab pelanggan 24/7 berdasarkan produk, harga, FAQ & data perniagaan sebenar melalui API.",
    f_inbox_t: "Shared Team Inbox", f_inbox_d: "Satu channel WhatsApp diurus ramai staff: ALL, NEW, AI Handling, Hot Leads, Follow-Up.",
    f_takeover_t: "Human Takeover", f_takeover_d: "Staff sambung dengan profil pelanggan, ringkasan AI, lead score & tindakan disyorkan.",
    f_score_t: "AI Lead Scoring", f_score_d: "AI beri skor HOT 92/100 & cadang 'Contact Now' untuk lead paling berpotensi.",
    f_broadcast_t: "Approved Broadcast", f_broadcast_d: "Kempen broadcast patuh polisi dengan template diluluskan Meta & audience opt-in.",
    f_automation_t: "Automation Builder", f_automation_d: "WHEN pelanggan buat X, IF syarat Y, THEN lakukan Z. Follow-up automatik.",
    f_crm_t: "CRM + Sales Pipeline", f_crm_d: "Setiap nombor jadi profil pelanggan. Pipeline NEW → QUALIFIED → WON.",
    f_analytics_t: "Analytics & Revenue", f_analytics_d: "Ukur replies, leads, sales, conversion & ROI setiap kempen WhatsApp.",
    pricing_eyebrow: "Harga",
    pricing_title: "Harga telus. Naik taraf bila anda berkembang.",
    pricing_sub: "Bayar 10 bulan, guna 12 bulan untuk pelan tahunan.",
    per_month: "/bulan", start_now: "Mula Sekarang",
    pricing_note_label: "Struktur harga penting:",
    pricing_note: "Yuran langganan tidak termasuk secara automatik semua caj WhatsApp/Meta. Anda bayar (1) langganan platform, (2) caj mesej WhatsApp/Meta di mana berkenaan, (3) penggunaan AI melebihi kuota pelan. Kami menjual",
    pricing_note_bold: "Approved WhatsApp Broadcast",
    pricing_note_end: "— bukan \"unlimited blast\".",
    cta_title: "Satu Platform WhatsApp Untuk Seluruh Bisnes Anda.",
    tag_entry: "Entry-level", tag_popular: "Paling Popular", tag_scaling: "Terbaik untuk berkembang", tag_multibranch: "Multi-cawangan",
  },
  en: {
    nav_features: "Features", nav_pricing: "Pricing", nav_solutions: "Solutions", nav_demo: "Book Demo",
    nav_login: "Log In", nav_trial: "Start Free Trial",
    hero_badge: "#1 WhatsApp AI CRM Platform in Malaysia",
    hero_title: "Turn WhatsApp Into Your AI Sales Team.",
    hero_sub: "AI Chatbot. CRM. Team Inbox. Approved Broadcast. Sales Automation. Serve customers 24/7, automate follow-ups, distribute leads to your team and measure sales from WhatsApp.",
    hero_cta1: "Start Free Trial", hero_cta2: "Book Demo",
    hero_from: "From RM99/month",
    hero_nocard: "No card needed", hero_setup: "5-minute setup",
    lang_toggle: "BM",
    convert_label: "Don't Just Chat. Convert.",
    features_eyebrow: "One Platform",
    features_title: "Everything you need to sell on WhatsApp.",
    features_sub: "WhatsApp stays the channel. Our platform becomes the AI, CRM, automation & revenue layer around it.",
    f_chatbot_t: "AI WhatsApp Chatbot", f_chatbot_d: "AI answers customers 24/7 from your products, pricing, FAQs & real business data via API.",
    f_inbox_t: "Shared Team Inbox", f_inbox_d: "One WhatsApp channel managed by many staff: ALL, NEW, AI Handling, Hot Leads, Follow-Up.",
    f_takeover_t: "Human Takeover", f_takeover_d: "Staff continue with the customer profile, AI summary, lead score & suggested next action.",
    f_score_t: "AI Lead Scoring", f_score_d: "AI scores leads HOT 92/100 and recommends 'Contact Now' for your best prospects.",
    f_broadcast_t: "Approved Broadcast", f_broadcast_d: "Policy-compliant broadcast campaigns with Meta-approved templates & opted-in audiences.",
    f_automation_t: "Automation Builder", f_automation_d: "WHEN a customer does X, IF condition Y, THEN do Z. Automatic follow-ups.",
    f_crm_t: "CRM + Sales Pipeline", f_crm_d: "Every number becomes a customer profile. Pipeline NEW → QUALIFIED → WON.",
    f_analytics_t: "Analytics & Revenue", f_analytics_d: "Measure replies, leads, sales, conversion & ROI for every WhatsApp campaign.",
    pricing_eyebrow: "Pricing",
    pricing_title: "Transparent pricing. Upgrade as you grow.",
    pricing_sub: "Pay 10 months, use 12 months on annual plans.",
    per_month: "/month", start_now: "Get Started",
    pricing_note_label: "Important pricing structure:",
    pricing_note: "Your subscription does not automatically include all WhatsApp/Meta charges. You pay for (1) the platform subscription, (2) WhatsApp/Meta message charges where applicable, (3) AI usage above your plan quota. We sell",
    pricing_note_bold: "Approved WhatsApp Broadcast",
    pricing_note_end: "— not \"unlimited blast\".",
    cta_title: "One WhatsApp Platform For Your Entire Business.",
    tag_entry: "Entry-level", tag_popular: "Most Popular", tag_scaling: "Best for scaling", tag_multibranch: "Multi-branch",
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState("en");
  const t = (key) => translations[lang][key] || key;
  const toggle = () => setLang((l) => (l === "ms" ? "en" : "ms"));
  return <LangContext.Provider value={{ lang, t, toggle }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
